// @flow

/**
 * Module dependencies.
 */

// $FlowFixMe
import 'client/assets/styles/main.scss';
import 'client/styles/global';
import { I18nextProvider } from 'react-i18next';
import { render } from 'react-dom';
import React from 'react';
import Root from 'client/containers/root';
import i18n from 'client/translations/i18n';

/**
 * App.
 */

function App(): React$Element<*> {
  return (
    <I18nextProvider i18n={i18n}>
      <Root />
    </I18nextProvider>
  );
}

/**
 * Render.
 */

render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ../src/client/index.js